module.exports = __webpack_public_path__ + "static/media/18ECA41.188fa9f5.jpg";